module.exports = __webpack_public_path__ + "static/media/weathericons-regular-webfont.4618f0de2a818e7ad3fe880e0b74d04a.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/weathericons-regular-webfont.ttf
// module id = 269
// module chunks = 0